
// ポイント取得
async function getPoint() {
  let point;

  await fetch(APP_PROXY_PATH + '/point', {
    method: 'GET'
  }).then(function(response){
    if (!response.ok) {
      return null;
    }
    else{
      return response.json();
    }
  }).then(function(json) {
    let error_flg = json['error_flg'];
    if(error_flg){
      throw new Error();
    }
    else{
      let key = json['point'];
      point = key;
    }
  }).catch(function(response) {
    console.log(response);
    return null;
  });
  return point;
}

// ポイント表示
async function displayPoint(customerId) {
  
  let point;
  const now = new Date(Date.now()); 
  let loading_sp = document.getElementById('point_loading_sp');
  let loading_pc = document.getElementById('point_loading_pc');

  //読み込み中くるくる表示
  if(loading_sp != null) loading_sp.style.display ="block";
  if(loading_pc != null) loading_pc.style.display ="block";
  
  if (localStorage.getItem("sanyo_app_current_point_" + customerId) && localStorage.getItem("sanyo_app_current_rank_id_" + customerId)) {
    point = localStorage.getItem("sanyo_app_current_point_" + customerId);
    let customer_point_sp = document.getElementById('customer_point_sp');
    let customer_point_pc = document.getElementById('customer_point_pc');
      
    if(customer_point_sp != null) customer_point_sp.innerHTML = point + ' point';
    if(customer_point_pc != null) customer_point_pc.innerHTML = point + ' point';
  } else {
    result = await getPointAndSetLocalStorage(customerId);
  }
  
  //読み込み中くるくる非表示
  if(loading_sp != null)loading_sp.style.display ="none";
  if(loading_pc != null)loading_pc.style.display ="none";
}

// ポイントのキャッシュを削除するか確認
function checkPointCache(customerId) {

  const now = new Date(Date.now());
  const url = location.pathname;
  const cachePointDate = localStorage.getItem("sanyo_app_expire_date_" + customerId);

  if(cachePointDate){
    if(url.match(/cart/)){
      clearPointCache(customerId);
    }
    else if(now.getTime() - cachePointDate >= POINT_CACHE_TTL){
      clearPointCache(customerId);
    }
  }
}

// ポイント関係のローカルストレージ削除
function clearPointCache(customerId) {
  localStorage.removeItem("sanyo_app_current_point_" + customerId);
  localStorage.removeItem("sanyo_app_expire_date_" + customerId);
}

// ページ読み込み時実行処理
document.addEventListener("DOMContentLoaded",function(){
  
//ログイン状態確認
if (document.getElementById('login')){
  const login = document.getElementById('login').value;
  let customerId = document.getElementById('customerId').value;
  checkPointCache(customerId);
  displayPoint(customerId);
}else{
  console.log('Not Login');
}
});